import React from 'react'
import { tokens } from '../../styles/desertFloraTheme'

const SEGMENTS = [
  { value: 'firm', label: 'Firm', activeBackground: tokens.ok, showDot: true },
  { value: 'allowance', label: 'Allowance', activeBackground: tokens.accent, showDot: false },
  { value: 'tbd', label: 'TBD', activeBackground: tokens.warn, showDot: false }
]

const styles = {
  container: {
    display: 'inline-flex',
    background: tokens.bg2,
    borderRadius: 999,
    padding: 3,
    border: '1px solid ' + tokens.line
  },
  segment: {
    padding: '5px 12px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.12s',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    border: 'none',
    outline: 'none',
    lineHeight: 1.2
  },
  dot: {
    width: 5,
    height: 5,
    borderRadius: '50%',
    background: 'currentColor',
    flexShrink: 0
  }
}

const StatusSegmented = ({ value, onChange }) => {
  return (
    <div style={styles.container}>
      {SEGMENTS.map((seg) => {
        const active = value === seg.value
        const segStyle = {
          ...styles.segment,
          background: active ? seg.activeBackground : 'transparent',
          color: active ? '#fbf8f1' : tokens.ink3
        }
        return (
          <button
            key={seg.value}
            type="button"
            style={segStyle}
            onClick={() => onChange && onChange(seg.value)}
          >
            {seg.showDot && <span style={styles.dot} />}
            {seg.label}
          </button>
        )
      })}
    </div>
  )
}

export default StatusSegmented
